import { PropsWithChildren, useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import { auth } from "../config/firebase"
import firebase from "firebase/compat/app"

export const AuthGate: React.FC<PropsWithChildren> = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState<firebase.User | null>(null)

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((u) => {
      setUser(u)
      setLoading(false)
    })
    return () => unsub()
  }, [])

  if (loading) return <div>Loading...</div>

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
